<template>
  <div class="container">
    <div
      class="selected-container"
      :class="{
        'selected-container disabled': disabled
      }"
      :style="customStyle"
      @click="onShowList"
    >
      <div
        class="image-container"
        :style="'background-color: ' + (selectedItem ? selectedItem.avatarColor : '#98A0AD')"
      >
        <img :src="imgUrl" alt="image" :class="type === 'group' ? 'image group' : 'image person'" />
      </div>
      <span class="text">{{ selectedItem ? selectedItem.name : 'Choose' }}</span>
      <img v-if="!disabled" src="@/assets/images/dropdown.png" class="dropdown-img" alt="dropdown" />
    </div>
    <div v-if="showList && !disabled" class="list">
      <div v-for="(item, index) in data" :key="index" class="list-item" @click="onClickItem(item)">
        <div
          class="item-avatar"
          :class="{
            'item-avatar group': type === 'group'
          }"
          :style="'background-color: ' + item.avatarColor"
        >
          {{ item.avatarName }}
        </div>
        <div class="item-name">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CallFlowDropdown',
  props: {
    type: String,
    customStyle: String,
    data: Array,
    onSelect: Function,
    selectedItem: Object
  },
  data() {
    return {
      showList: false,
      disabled: false
    };
  },
  computed: {
    imgUrl() {
      const images = require.context('@/assets/images', false, /\.png$/);
      return images('./' + this.type + '_white.png');
    }
  },
  mounted() {
    if (this.data.length === 1) {
      this.onSelect(this.data[0]);
      this.disabled = true;
    }
  },
  methods: {
    onShowList() {
      this.showList = !this.showList;
    },
    onClickItem(item) {
      this.showList = false;
      this.onSelect(item);
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  position: relative;
}

.selected-container {
  width: 315px;
  height: 90px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(83, 95, 119, 0.15);
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 26px 0 10px;
  cursor: pointer;

  &.disabled {
    cursor: unset;
  }

  .image-container {
    width: 65px;
    height: 65px;
    background: $colorPlaceholder;
    box-shadow: 0px 0px 2px rgba(78, 78, 78, 0.4);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .image {
      &.group {
        width: 54px;
        height: 35px;
      }
      &.person {
        width: 40px;
        height: 40px;
        margin-top: 3px;
      }
    }
  }

  .text {
    flex: 1;
    font-weight: 500;
    font-size: 24px;
    line-height: 20px;
    letter-spacing: -0.01em;
    color: $colorText;
    margin-left: 25px;
  }

  .dropdown-img {
    width: 16px;
    height: 10px;
  }
}

.list {
  position: absolute;
  left: 105px;
  top: 85px;
  width: 290px;
  max-height: 250px;
  background: #ffffff;
  border: 0.2px solid #d4d6d8;
  box-shadow: 2px 2px 10px rgba(83, 95, 119, 0.15);
  border-radius: 10px;
  padding: 15px 0;
  overflow: auto;
  z-index: 9999;

  .list-item {
    width: 100%;
    height: 55px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    padding: 0 20px;
    &:hover {
      background-color: $colorBack;
    }

    .item-avatar {
      width: 30px;
      height: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 20px;
      font-weight: 500;
      font-size: 16px;
      line-height: 15px;
      text-align: center;
      letter-spacing: 0.03em;
      color: #ffffff;

      &.group {
        border-radius: 5px;
      }
    }

    .item-name {
      flex: 1;
      font-weight: 500;
      font-size: 18px;
      line-height: 20px;
      letter-spacing: -0.01em;
      margin-left: 15px;
      color: $colorText;
    }
  }
}
</style>
